export default {
  en: {
    'CONVERSION_ADJUSTMENT_BUTTON_TT': 'Dispute Call',
    'CONVERSION_ADJUSTMENT_REASON_LABEL': 'Dispute Reason',
    'CONVERSION_ADJUSTMENT_REASON_TT': 'Please provide the reason for disputing the validity of this call.',
    'CONVERSION_ADJUSTMENT_AMOUNT_LABEL': 'Revenue',
    'CONVERSION_ADJUSTMENT_AMOUNT_TT': 'Please provide the amount to override the revenue amount.',
    'CONVERSION_ADJUSTMENT_NO_CONVERSION': 'Cannot adjust revenue amount because call did not convert.',
    'CONVERSION_ADJUSTMENT_SEND_BTN': 'Submit Dispute',

    'PAYOUT_ADJUSTMENT_BUTTON_TT': 'Adjust Call Payments',
    'PAYOUT_ADJUSTMENT_AMOUNT_LABEL': 'Payout',
    'PAYOUT_ADJUSTMENT_AMOUNT_TT': 'Please provide an optional amount to override the payout of this call.',
  
    'PAYOUT_ADJUSTMENT_SEND_BTN': 'Update Payout/Revenue',

    'ORIGINAL_VALUE_UNCHANGED': 'Original Value Unchanged',

    'PENDING_CONVERSION_TT': 'Dispute Pending',
    'APPROVED_CONVERSION_TT': 'Dispute Approved for {{amount}} adjustment. Click to dispute again',
    'REJECTED_CONVERSION_TT': 'Dispute Rejected. Click to dispute again',

    'CONVERSION_PREVIEW_LABEL_BUYER': 'Current revenue - Revenue adjustment',
    'UNQUALIFIED_CALL_TT': 'No revenue to adjust',
    'CONVERSION_ADJUSTMENT_MIN_INVALID': 'The new revenue cannot be less than 0',
    'PAYOUT_ADJUSTMENT_MIN_INVALID': 'The new payout cannot be less than 0',

    'CALL_PAYMENTS_UPDATE_CONFIRMATION': 'Payment Adjustment Confirmation',
    'REVIEW_CHANGES': 'Review payment changes',
    'BULK_CONVERSION_ADJUSTMENT_MESSAGE': 'All calls ({adjustmentCount}) in the current report will be adjusted. When the job is complete, an email notification containing the adjustment details will be sent.',
    'SINGLE_CONVERSION_ADJUSTMENT_MESSAGE': 'When the job is complete, an email notification containing the adjustment details will be sent.'
  }
};